import React, { useState } from "react";

function FilterGroup({ title, options }) {
  const [open, setOpen] = useState(true);

  return (
    <div className="filter_group">
      {/* Heading with toggle */}
      <div className="filter_header" onClick={() => setOpen(!open)}>
        <h5 className="filter_title">{title}</h5>
        <span className="toggle_icon">{open ? "−" : "+"}</span>
      </div>

      {open && (
        <div className="filter_options">
          <ul>
            {options.map((opt, i) => (
              <li key={i}>
                <label>
                  <input type="checkbox" defaultChecked={opt.checked} />
                  {opt.label}
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function AlgoFilters() {
  const [open, setOpen] = useState(false);

  // Close sidebar on outside click
  const handleOverlayClick = () => {
    setOpen(false);
  };

  return (
    <>
      {/* Mobile Filter Button */}
      <button className="filter_toggle_btn" onClick={() => setOpen(true)}>
        Filters <i class="fa-solid fa-sliders"></i>
      </button>

      {/* Overlay */}
      {open && <div className="overlay" onClick={handleOverlayClick}></div>}

      {/* Sidebar Filters */}
      <aside className={`algo_filters sidebar_bg ${open ? "open" : ""}`}>
        {/* Close Button inside sidebar */}
        <button className="close_btn" onClick={() => setOpen(false)}>
          ×
        </button>

        <h3 className="widget_title">Filters</h3>

        <FilterGroup
          title="Type"
          options={[
            { label: "All", checked: true },
            { label: "Most Deployed", checked: true },
            { label: "Newly Added", checked: true },
            { label: "Experimental" },
            { label: "Trending" },
            { label: "Archived" },
          ]}
        />

        <FilterGroup
          title="Minimum Capital"
          options={[
            { label: "All", checked: true },
            { label: "₹50,000 – ₹1,00,000" },
            { label: "₹1,00,000 – ₹5,00,000" },
            { label: "Above ₹5,00,000" },
          ]}
        />

        <FilterGroup
          title="Duration"
          options={[
            { label: "All", checked: true },
            { label: "Intraday" },
            { label: "Positional" },
            { label: "BTST / STBT" },
          ]}
        />

        <FilterGroup
          title="Segment"
          options={[
            { label: "All", checked: true },
            { label: "Equity (Cash)" },
            { label: "F&O (Futures & Options)" },
            { label: "Commodity" },
          ]}
        />

        {/* Underlying */}
        <div className="filter_group">
          <h5 className="filter_title">Underlying</h5>
          <div className="search_box">
            <input
              type="text"
              placeholder="Search..."
              className="filter_search"
            />
            <i className="fa-brands fa-sistrix search_icon"></i>
          </div>

          <div className="filter_options scrollable">
            <ul>
              <li>
                <label>
                  <input type="checkbox" defaultChecked /> All
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Nifty
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Bank Nifty
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Midcap Nifty
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> FinNifty
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Sensex
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <a href="#" className="btn_style_one w-100 text-center">
            Reset All Filters
          </a>
        </div>
      </aside>
    </>
  );
}

export default AlgoFilters;
